module.exports = __webpack_public_path__ + "static/img/livelist.ae85500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/livelist.png
// module id = +7+z
// module chunks = 1